/**
 * The Huginn mark — two beaks facing inward.
 *
 * Taken from the landing page (`huginn_landing_v2.html`), which is the canonical lockup: a navy
 * beak and a teal beak turned toward each other, paired with "Huginn" at 19px/600 with 11px
 * between them.
 *
 * ONE ADJUSTMENT, and it is why this is a component rather than a copied `<svg>`. The landing
 * page is a light page, so it hard-codes navy #14243C for the left beak. The app bar is navy —
 * that beak would disappear into it. So the left beak takes `currentColor` and the right takes
 * `--rm-mark-accent`, which means the same component is:
 *
 *   on a light surface   navy + teal        (the landing page lockup, unchanged)
 *   on the navy bar      white + light teal (set by the bar, see Header.module.css)
 *
 * Hard-coding the colours would have forced a second copy of the mark, and two copies of a logo
 * drift.
 */
export default function HuginnMark({ size = 27, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      style={{ overflow: 'visible' }}
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {/* `data-beak` makes each raven addressable from a caller's stylesheet without this
          component knowing anything about motion. The auth page animates them; the bar does not,
          and gets no styles here to inherit. Nothing is attached by default — the attributes are
          a handle, not a hook. */}
      <path
        data-beak="left"
        d="M6 12 L17 20 L6 28"
        stroke="currentColor"
        strokeWidth="2.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        data-beak="right"
        d="M34 12 L23 20 L34 28"
        stroke="var(--rm-mark-accent, var(--rm-teal, #0F6E56))"
        strokeWidth="2.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
